import axios from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";
import { blueprintsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";

export const updateBlueprint = async (
  id: string,
  name: string,
  description: string,
  author: string,
  organization: string,
  root_node: unknown,
  dashboard_data: unknown,
  alarm_profiles: unknown,
  namespace: string,
) => {
  const url = blueprintsUrlEnvVar();
  return axios({
    url: `${url}/api/v3/ns/${namespace}/blueprints/${id}`,
    method: "PUT",
    headers: buildAxiosAuthenticationHeaders(),
    data: {
      namespace,
      name,
      description,
      author,
      organization,
      root_node,
      dashboard: dashboard_data,
      alarm_profiles,
    },
    validateStatus: (status) =>
      (status >= 200 && status < 300) || status === 422,
  })
    .then((response) => response.data)
    .then((data) => {
      if (data !== undefined) {
        return data;
      }
    })
    .catch((err) => {
      if (err?.response?.data?.message === "Refresh Token is expired") {
        navigateTo(Route.TOKENS_EXPIRED_ERROR);
      } else {
        navigateTo(Route.SERVER_ERROR);
      }
    });
};
